import { gameByCode, gameNameOf } from '@/lib/limulo/profiles';
import { useGetLimuloGamesQuery } from '@/services/limuloApi';

/**
 * Il nome di un gioco dal codice che porta un torneo (`tournament.gameId`), per la card.
 *
 * ⚠️ **Una sola lettura del catalogo**: e' la stessa query RTK di `/v1/games` che usano la lobby
 * backgammon, la scheda dell'incontro e l'azione persistente (stesso argomento `undefined`,
 * quindi stessa chiave di cache). Due letture dello stesso catalogo divergono.
 * ⚠️ **`skip`** e' la serratura del flag Limulo: con la sezione spenta nessuna chiamata.
 *
 * Finche' il catalogo non risponde, o se il gioco non c'e', `name` e' il codice grezzo
 * (`gameNameOf`), e `fromCatalog` e' `false`.
 */
export function useLimuloGameName(
  gameId: string,
  { skip = false }: { skip?: boolean } = {},
): { name: string; fromCatalog: boolean } {
  const { data: giochi } = useGetLimuloGamesQuery(undefined, { skip: skip || gameId === '' });
  return {
    name: gameNameOf(gameId, giochi),
    fromCatalog: gameByCode(gameId, giochi ?? []) !== null,
  };
}
